<template>
  <div class="cursor-container">
    <div class="cursor-inner" ref="cursor">
      <svg class="cursor" height="500" width="500">
        <circle class="cursor__circle" cx="250" cy="250" r="60" />
      </svg>
    </div>
  </div>
</template>

<script>
import apollo from '@/scripts/apollo';
import engine from '@/scripts/engine';

export default {
  name: 'AppCursor',
  mounted() {
    engine.start();
    apollo.init(this.$refs.cursor);
  },
};
</script>

<style scoped lang="scss">
.cursor-container {
  z-index: 100;

  @include mq($and: $is-touch-device) {
    display: none;
  }
}

.cursor {
  z-index: 100;
  backface-visibility: hidden;

  &-inner {
    top: 0;
    left: 0;
    position: fixed;

    pointer-events: none;
    will-change: transform;
    backface-visibility: hidden;

    z-index: 100;
  }

  &__circle {
    fill: transparent;
    stroke: $color-primary;
    stroke-width: 1;
    opacity: 0.7;
  }
}
</style>
